import { render } from "./allsales.vue?vue&type=template&id=611bf199&scoped=true"
import script from "./allsales.vue?vue&type=script&lang=js"
export * from "./allsales.vue?vue&type=script&lang=js"

import "./allsales.vue?vue&type=style&index=0&id=611bf199&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611bf199"]])

export default __exports__